import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import SocHeader from '../components/SocHeader.jsx';
import Footer from '../components/Footer.jsx';

export default function NotFound() {
  return (
    <>
      <SocHeader />
      <section className="auth-section" id="main">
        <div className="auth-card">
          <div className="eyebrow">404 &middot; Target not found</div>
          <h2 className="auth-headline">No signal at this coordinate.</h2>
          <p className="auth-sub">The route you tried doesn&apos;t exist on this build.</p>
          <Link to="/" className="btn btn-block">Return to Command Center <ArrowRight aria-hidden="true" /></Link>
        </div>
      </section>
      <Footer />
    </>
  );
}